import React from "react";
import { formatDateString } from "../../../components/util/helpers";

/**
 *
 * @param dateStr
 * @param prefix {string} - Optional text that should go before the date.
 */
function FormattedDate({ dateStr, prefix }) {
  return (
    <>
      {prefix && prefix + ": "} {formatDateString(dateStr)}
    </>
  );
}

export function Orders({
  customerLabel,
  fromText,
  maxHoursLabel,
  orders,
  toText,
}) {

  // Mock data for testing UI:
  // let oos = [
  //   {
  //     effective_from: "2023-10-01T00:00:00+03:00",
  //     effective_to: "2023-12-01T00:00:00+03:00",
  //     max_hours: 10,
  //     client: {
  //       name: "ועדת מ.א גליל תחתון",
  //       category: {
  //         name: "בטוח לאומי",
  //       },
  //     },
  //   },
  // ];

  return (
    <ion-list style={{ marginTop: "10px" }}>
      {orders &&
        orders.map((order) => {
          return (
            <ion-item-group key={order.id}>
              <ion-item-divider>
                <ion-label>
                  {" "}
                  <span style={{ fontSize: "6px" }}>
                    {customerLabel}: {order.client.category.name},{" "}
                    {order.client.name}
                  </span>
                </ion-label>
              </ion-item-divider>
              <ion-item>
                <ion-label>
                  {maxHoursLabel}: {order.max_hours}
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-label>
                  <FormattedDate
                    dateStr={order.effective_from}
                    prefix={fromText}
                  />
                  {order.effective_to && (
                    <>
                      {","}{" "}
                      <FormattedDate
                        dateStr={order.effective_to}
                        prefix={toText}
                      />
                    </>
                  )}
                </ion-label>
              </ion-item>
            </ion-item-group>
          );
        })}
    </ion-list>
  );
}
